import * as z from "zod";

// Partner branding attributed to the current team, for the "free with
// {partner}, already applied" chargebacks onboarding treatment.
export const getTeamPartnerAttribution = {
  name: "getTeamPartnerAttribution" as const,
  input: z.object({}),
  output: z
    .object({
      partnerName: z.string().max(256),
      logoUrl: z.string().max(2048).nullable(),
    })
    .nullable(),
};
